module.exports = __webpack_public_path__ + "img/29.4dbe3d4c.jpg";